import React from "react";
import { Link } from "react-router-dom";
import { DATE_FORMATS } from "../../utilities/constants";
import { formatDate } from "../../utilities/dateTimeUtils";
import { DataTableItem, DataTableRow, UserAvatar } from "../Component";

const UsersPageTableBodyItems = ({ item }) => {
  const displayName =
    [item?.firstName, item?.lastName].filter(Boolean).join(" ") ||
    item?.username ||
    item?.email ||
    "-";
  const initials =
    displayName !== "-"
      ? displayName
          .split(" ")
          .map((s) => s?.charAt(0))
          .join("")
          .toUpperCase()
          .slice(0, 2)
      : "-";
  const rolesText = Array.isArray(item?.roles)
    ? item.roles.join(", ")
    : item?.roles ?? "-";

  return (
    <DataTableItem>
      <DataTableRow noText>
        <Link to={`/users/${item.id}`} state={item}>
          <div className="user-card">
            <UserAvatar className="xs" text={initials} />
            <div className="user-info">
              <span className="tb-lead">{displayName}</span>
            </div>
          </div>
        </Link>
      </DataTableRow>
      <DataTableRow noText>
        <span className="tb-lead">{item?.email ?? "-"}</span>
      </DataTableRow>
      <DataTableRow
        size="sm"
        text={formatDate(item?.createdAt, DATE_FORMATS.DATE_REGISTERED)}
      />
      <DataTableRow noText>
        <span className="tb-lead">{rolesText}</span>
      </DataTableRow>
    </DataTableItem>
  );
};

export default UsersPageTableBodyItems;
